import React, { useState } from "react";
import Header from "../components/Header";
import { create as ipfsHttpClient } from "ipfs-http-client";
import Web3Modal from "web3modal";
import { ethers } from "ethers";
import { soulContractAddress } from "../config";

import SoulAbi from "../artifacts/contracts/Soul.sol/Soul.json";
import { navigate } from "raviger";

const client = ipfsHttpClient("https://ipfs.infura.io:5001/api/v0");

function Upload() {
  const [formData, setFormData] = useState({
    recipientUsername: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);

  const [fileUrl, setFileUrl] = useState(null);

  async function onChange(e) {
    const file = e.target.files[0];
    try {
      const added = await client.add(file, {
        progress: (prog) => console.log(`received: ${prog}`),
      });
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      console.log(url, added);
      setFileUrl(url);
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }

  async function uploadToIPFS() {
    const { recipientUsername, description } = formData;
    if (!description || !recipientUsername || !fileUrl) return;
    /* first, upload to IPFS */
    const data = JSON.stringify({
      description,
      image: fileUrl,
    });
    try {
      const added = await client.add(data);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      console.log("IPFS URL: ", url);
      /* after file is uploaded to IPFS, return the URL to use it in the transaction */
      return url;
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const url = await uploadToIPFS();
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();

    console.log("First half done");
    const SoulContract = new ethers.Contract(soulContractAddress, SoulAbi.abi, signer);
    const mint = await SoulContract.createToken(
      url,
      formData.recipientUsername,
      formData.description
    );
    const tx = await mint.wait();
    console.log(tx.events[0].args[2].toNumber());
    navigate(`/certificate/${formData.recipientUsername}`);
    setLoading(false);
  }

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      {/*  Site header */}
      <Header />
      {/*  Page content */}
      <main className="flex-grow">
        <section className="bg-gradient-to-b from-gray-100 to-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="pt-32 pb-12 md:pt-40 md:pb-20">
              {/* Page header */}
              <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
                {loading ? (
                  <h1 className="text-5xl font-extrabold">Loading....</h1>
                ) : (
                  <>
                    <h1 className="text-5xl font-extrabold">
                      Upload a new file to the SBT token network
                    </h1>
                    <h2 className="text-xl font-medium leading-relaxed tracking-tight mb-4 text-red-500">
                      <span className="text-xl font-bold leading-tighter tracking-tighter">
                        Note
                      </span>{" "}
                      Files once uploaded cannot be taken down or cannot be edited
                    </h2>
                  </>
                )}
              </div>

              {/* Form */}
              <div className="max-w-sm mx-auto">
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-wrap -mx-3 mb-4">
                    <div className="w-full px-3">
                      <label
                        className="block text-gray-800 text-sm font-medium mb-1"
                        htmlFor="recipient-address"
                      >
                        Recipient Address <span className="text-red-600">*</span>
                      </label>
                      <input
                        id="recipient-address"
                        type="text"
                        value={formData.recipientUsername}
                        onChange={(e) =>
                          setFormData({ ...formData, recipientUsername: e.target.value })
                        }
                        className="bg-white border border-gray-300 focus:border-gray-500 py-3 px-4 w-full text-gray-800"
                        placeholder="Enter the recipient's wallet address"
                        required
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mx-3 mb-4">
                    <div className="w-full px-3">
                      <label
                        className="block text-gray-800 text-sm font-medium mb-1"
                        htmlFor="description"
                      >
                        Description <span className="text-red-600">*</span>
                      </label>
                      <input
                        id="description"
                        type="text"
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        className="bg-white border border-gray-300 focus:border-gray-500 py-3 px-4 w-full text-gray-800"
                        placeholder="Enter the description of the certificate"
                        required
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap -mx-3 mb-4">
                    <div className="w-full px-3">
                      <label
                        className="block text-gray-800 text-sm font-medium mb-1"
                        htmlFor="certificate"
                      >
                        Upload Certificate <span className="text-red-600">*</span>
                      </label>
                      <input
                        id="certificate"
                        type="file"
                        className="bg-white border border-gray-300 focus:border-gray-500 py-3 px-4 w-full text-gray-800"
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  {fileUrl && (
                    <img className="rounded mt-4" width="350" alt="loading..." src={fileUrl} />
                  )}
                  <div className="flex flex-wrap -mx-3 mt-6">
                    <div className="w-full px-3">
                      <button
                        type="submit"
                        className="font-medium inline-flex items-center justify-center border border-transparent rounded leading-snug transition duration-150 ease-in-out px-8 py-3 shadow-lg text-white bg-blue-600 hover:bg-blue-700 w-full"
                      >
                        Issue Certificate
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Upload;
